import PageHeader from "@/components/pageHeader";
import { ArrowRight, Play } from "lucide-react";

export const SpotlightPage = () => {
  // Press of Honour items (sourced from gillcogroup.com/gillco-spotlight)
  const media = [
    {
      title: "Gillco Group to invest ₹800 crore to develop 12-acre housing project in Mohali",
      excerpt: "Gillco Group will invest ₹800 crore to develop Gillco Meraqui, a residential project in sector 126, Mohali, informed Tejpreet Singh Gill, managing director, of the company. The project will comprise 444 apartments across six towers, with total revenue potential estimated at ₹2,300-2,400 crore. The company has initially opened 250 apartments for sale, for which it is investing about ₹400-450 crore. The sales realisation of 250 apartments is expected to be about ₹1,200 crore.",
      date: "2026",
      image: "/assets/spotlight/investmentEt.jpeg",
      link: "https://realty.economictimes.indiatimes.com/amp/news/industry/gillco-group-announces-800-crore-investment-in-luxury-housing-project-in-mohali/132221220",
      tag: "Announcement",
    },
  
    {
      title: "Gillco Unveils Meraqui In Style",
      excerpt: "The grand unveiling of Meraqui — Gillco's premium high-rise lifestyle development in Sector 126, Mohali.",
      date: "2024",
      image: "/assets/meraqui/meraquiStory.jpeg",
      link: "https://www.youtube.com/watch?v=TqHjVUC5JYs",
      tag: "Launch",
    },
      
    {
      title: "Tricity's Biggest Run for Health Marathon",
      excerpt: "Gracing the Chandigarh Tribune — Gillco Group leads the Tricity's biggest health initiative.",
      date: "2024",
      image: "/assets/spotlight/marathon.jpg",
      link: "https://www.facebook.com/story.php?story_fbid=697602172071391&id=100054648421520",
      tag: "Community",
    },
    {
      title: "Gillco Group Featured in Business Standard",
      excerpt: "Business Standard spotlights Gillco's enduring commitment to quality and innovation in real estate.",
      date: "2024",
      image: "/assets/spotlight/businessStandard.jpg",
      link: "https://www.facebook.com/story.php?story_fbid=751131693385105&id=100054648421520",
      tag: "Press",
    },
    {
      title: "Newspaper Coverage",
      excerpt: "Gillco Group's projects and milestones celebrated across leading regional and national newspapers.",
      date: "2023",
          image: "/assets/spotlight/punjabTimes.jpg",

      link: "https://www.facebook.com/story.php?story_fbid=771045951393679&id=100054648421520",
      tag: "Press",
    },
    {
      title: "Introducing Gillco Spotlight",
      excerpt: "A new identity designed to set the stage for Gillco Group — unveiling our refreshed brand voice and storytelling.",
      date: "2023",
      image: "/assets/spotlight/spotlight.jpg",
      link: "https://www.facebook.com/gillcogroupofficial/videos/846479466821412/",
      tag: "Brand",
    },
    {
      title: "Featured in Forbes Magazine",
      excerpt: "The reputed Forbes magazine recognises Gillco Group's outstanding contribution to Indian real estate.",
      date: "2022",
      image: "/assets/spotlight/forbes.jpg",
      link: "https://www.facebook.com/story.php?story_fbid=880276060470667&id=100054648421520",
      tag: "Recognition",
    },
    {
      title: "Icons of India 2022",
      excerpt: "India Today honours Gillco Group as the face of the region's most successful real estate enterprise.",
      date: "2022",
      image: "/assets/spotlight/iconIndia.jpg",
      link: "https://www.facebook.com/gillcogroupofficial/photos/pb.100054648421520.-2207520000/1787336988277813/",
      tag: "Recognition",
    },
  ];

  const [featured, ...rest] = media;

  return (
    <div data-testid="v13-spotlight-page">
      <PageHeader title="Press & Media" subtitle="In the Spotlight" backgroundImage="/assets/banner/spotlight-banner.avif" />

      {/* Editorial hero — matches Journey / About style */}
      <section className="bg-white pt-24 lg:pt-32 pb-16 lg:pb-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="flex gap-8 lg:gap-16">
            <div className="hidden md:flex flex-col items-center">
              <span
                className="text-[11px] tracking-[0.3em] uppercase text-[#C4A265]"
                style={{ writingMode: "vertical-lr", letterSpacing: "0.3em" }}
              >
                PRESS OF HONOUR
              </span>
              <div className="w-[1px] bg-[#C4A265] flex-1 mt-4 min-h-[120px]" />
            </div>
            <div className="flex-1">
              <h2
                className="text-4xl sm:text-5xl lg:text-6xl text-[#0A0A0A] mb-10 lg:mb-12 leading-[1.05] relative inline-block pr-6"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Success is Cherished<br />When Shared
                <span className="absolute bottom-3 -right-2 w-2 h-2 rounded-full bg-[#C4A265]" />
              </h2>
              <p className="text-[#4A4A4A] leading-relaxed max-w-3xl" style={{ textAlign: "justify" }}>
                We have stood the test of time and emerged as an award-winning real estate developer. Over the last two decades, we have grown as a big Punjabi family — where promises, commitments and responsibilities towards the people who placed their trust in us have come to fruition. Here is a glimpse of our communities' accolades, and the moments that shaped our story.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured story — magazine cover */}
      <section className="bg-[#f8f6f2] py-20 lg:py-24 border-y border-[#C4A265]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#C4A265] mb-8 font-medium">Featured Story</div>
          <a
            href={featured.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group grid lg:grid-cols-12 gap-10 lg:gap-14 items-center"
            data-testid="v13-spotlight-featured"
          >
            <div className="lg:col-span-7 overflow-hidden bg-[#ece6d8]">
              <div className="aspect-[4/4] overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-1000"
                />
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="flex items-center gap-3 mb-5">
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#0A4F3B] bg-white px-3 py-1 border border-[#0A4F3B]/20">{featured.tag}</span>
                <span className="text-[11px] uppercase tracking-[0.3em] text-[#C4A265]">{featured.date}</span>
              </div>
              <h3
                className="text-3xl lg:text-5xl text-[#0A0A0A] font-light leading-[1.1] mb-5 group-hover:text-[#0A4F3B] transition-colors duration-500"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {featured.title}
              </h3>
              <div className="w-14 h-[2px] bg-[#C4A265] mb-5 group-hover:w-24 transition-all duration-500" />
              <p className="text-[15px] text-[#4A4A4A] leading-[1.85] mb-6" style={{ textAlign: "justify" }}>
                {featured.excerpt}
              </p>
              <span className="inline-flex items-center gap-2 text-[#0A4F3B] text-sm font-medium group-hover:gap-3 transition-all">
                <Play size={14} className="text-[#C4A265]" /> Watch the Coverage
              </span>
            </div>
          </a>
        </div>
      </section>

      {/* Press grid — 3 column masonry-style cards */}
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-12 lg:mb-16">
            <div>
              <div className="text-[10px] uppercase tracking-[0.4em] text-[#C4A265] mb-3 font-medium">In the Media</div>
              <h3
                className="text-3xl lg:text-4xl text-[#0A0A0A] font-light leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                More from Our Press Coverage
              </h3>
            </div>
            <div className="hidden lg:block w-24 h-[1px] bg-[#C4A265]/40 mb-3" />
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-9">
            {rest.map((m, i) => (
              <a
                key={i}
                href={m.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col bg-white border border-[#C4A265]/15 hover:border-[#C4A265] transition-all duration-500 hover:shadow-[0_20px_60px_-15px_rgba(196,162,101,0.25)] overflow-hidden"
                data-testid={`v13-spotlight-card-${i}`}
              >
                <div className="aspect-[4/3] overflow-hidden bg-[#f8f6f2]">
                  <img
                    src={m.image}
                    alt={m.title}
                    className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-700"
                  />
                </div>
                <div className="p-6 lg:p-7 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-[9px] uppercase tracking-[0.3em] text-[#0A4F3B] bg-[#0A4F3B]/8 px-2 py-1 border border-[#0A4F3B]/15">{m.tag}</span>
                    <span className="text-[10px] uppercase tracking-[0.3em] text-[#C4A265]">{m.date}</span>
                  </div>
                  <h4
                    className="text-xl lg:text-2xl text-[#0A0A0A] font-light leading-[1.2] mb-3 group-hover:text-[#0A4F3B] transition-colors duration-500"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {m.title}
                  </h4>
                  <div className="w-10 h-[1px] bg-[#C4A265] mb-4 group-hover:w-16 transition-all duration-500" />
                  <p className="text-sm text-[#4A4A4A] leading-relaxed mb-5 flex-1" style={{ textAlign: "justify" }}>
                    {m.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-2 text-[#0A4F3B] text-sm font-medium group-hover:gap-3 transition-all self-start">
                    Read More <ArrowRight size={14} />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};